/**
 *
 *
 * @author Shigq
 * @date 2019/11/27 17:59
 */

import axios from 'axios'
import { utils } from '@libs/ui'
import { commonUtils } from '@libs/utils'
// import { platformChannel } from '@/config'

const baseURL = process.env.VUE_APP_BASE_URL
/* 下载方法 */
function downFile(blob, fileName) {
  // 非IE下载`
  if ('download' in document.createElement('a')) {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob) // 创建下载的链接
    link.download = fileName // 下载后文件名
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click() // 点击下载
    window.URL.revokeObjectURL(link.href) // 释放掉blob对象
    document.body.removeChild(link) // 下载完成移除元素
  } else {
    // IE10+下载
    window.navigator.msSaveBlob(blob, fileName)
  }
}

export const downloadFile = function(url, data) {
  // let requestData = Object.assign({}, data, {
  // accessToken: sessionStorage.getItem('accessToken')
  // });

  const requestData = commonUtils.dataSerializer(data)

  // 响应类型：arraybuffer, blob
  axios.post(
    baseURL + url,
    requestData,
    {
      responseType: 'blob',
    }
  ).then(resp => {
    const headers = resp.headers
    const contentType = headers['content-type']

    // console.log('响应头信息', headers);
    if (!resp.data) {
      console.error('响应异常：', resp)
      return false
    } else {
      if (resp.data.type === 'application/json') {
        const reader = new FileReader()
        reader.readAsText(resp.data)
        reader.onload = function(e) {
          const data = JSON.parse(e.target.result)
          // todo - 根据当前系统使用【弹出提醒】和【header - message】
          utils.vab.baseMessage(data.header.message, 'error')
        }
      } else {
        const blob = new Blob([resp.data], { type: contentType })
        const contentDisposition = resp.headers['content-disposition']
        let fileName = 'unknown'
        if (contentDisposition) {
          fileName = window.decodeURI(resp.headers['content-disposition'].split('=')[1])
        }
        downFile(blob, fileName)
      }
    }
  }).catch(function(error) {
    console.log(error)
  })
}
